import { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { Toast } from "@sscs/ui";

export function errorIsFetchError(
  error: unknown,
): error is FetchBaseQueryError {
  return (error as FetchBaseQueryError).status !== undefined;
}

function isServerOrConnectionError(error: FetchBaseQueryError): boolean {
  return typeof error.status !== "number" || error.status >= 500;
}

export const apiErrorToast = (error: unknown, text: string) => {
  if (errorIsFetchError(error) && isServerOrConnectionError(error)) {
    Toast.show({
      title: text,
      type: "error",
    });
  }
};
